import React, { FC, Fragment } from "react";
import { Navigate, useLocation, useOutlet } from "react-router-dom";

import { GuestHeader } from "@components/common";
import { useUserStore } from "@store/user";

const GuestLayout: FC = () => {
  const outlet = useOutlet();
  const { user } = useUserStore();
  const location = useLocation();

  const redirectUrl = sessionStorage.getItem("redirectAfterLogin");

  if (user && location.pathname !== "/confirm-email") {
    if (redirectUrl) {
      sessionStorage.removeItem("redirectAfterLogin");

      return <Navigate to={redirectUrl} />;
    }

    return <Navigate to="/" />;
  }

  return (
    <Fragment>
      <GuestHeader />
      {outlet}
    </Fragment>
  );
};

export default GuestLayout;
